module.exports = __webpack_public_path__ + "img/bx-setting.6aa4e481.png";